import usePostMsgContext from '@apps/containers/WebviewProvider/hooks';
import { Box, Stack, Typography } from '@mui/material';
import Image from 'next/image';

import { QuickActionButtonListProps } from './props';
import { FeatureButtonIconWrapper } from './styles';

export const QuickActionButtonList: React.FC<QuickActionButtonListProps> = (
  props
) => {
  const { actions } = props;
  const { clickEvent } = usePostMsgContext();
  return (
    <Box
      sx={{
        display: 'grid',
        borderRadius: '4px',
        // border: '1px solid #4c4e6438',
        gridTemplateColumns: 'repeat(4, 1fr)',
      }}
    >
      {actions.map((action, index) => {
        const { icon, label, href, isNewPage, webView, landScape } = action;

        const onClick = !webView
          ? undefined
          : clickEvent(href ?? '/cars', false, {
              title: label,
              params: {
                ...(isNewPage && { type: 'trade-in' }),
                ...(landScape && { landScape: true }),
              },
            });
        return (
          <a
            href={href}
            onClick={onClick}
            target={isNewPage && !webView ? '_blank' : undefined}
            key={index}
            style={{
              display: 'inline-block',
              minWidth: 0,
            }}
          >
            <Stack
              direction="column"
              alignItems="center"
              gap={1}
              justifyContent={'space-between'}
            >
              <FeatureButtonIconWrapper>
                <Image
                  {...icon}
                  alt={icon.alt}
                  width={'0'}
                  height={'0'}
                  sizes="100vw"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                  }}
                />
              </FeatureButtonIconWrapper>
              <Typography
                sx={{
                  textAlign: 'center',
                  fontSize: { xs: 14, md: 16 },
                  fontWeight: 700,
                  width: '100%',
                  display: '-webkit-box',
                  flexWrap: 'nowrap',
                  '-webkit-line-clamp': '2',
                  '-webkit-box-orient': 'vertical',
                  overflow: 'hidden',
                  minHeight: '1.5rem' /* Adjust based on your line height */,
                  color: 'text.primary',
                }}
              >
                {label}
              </Typography>
            </Stack>
          </a>
        );
      })}
    </Box>
  );
};
